import React, { useState } from 'react';
import { Calendar } from 'lucide-react';
import FormattedTime from '../Common/FormattedTime.jsx';
import "./AnnouncementPage.css"; 

export default function AnnouncementCard({ 
    announcement, 
    onDelete, 
    committeeName, 
    studentName,
    index 
}) {
    // 1. Internal state for "View More" 
    const [isExpanded, setIsExpanded] = useState(false);

    // 2. Helper variables
    const isGoogle = announcement.source === 'GOOGLE_CALENDAR';
    const uniqueKey = announcement.announcement_id || announcement.id;

    // 3. Enhanced Color Logic with more sophisticated palette
    const getCommitteeColor = () => {
        if (isGoogle) return '#3b82f6'; // Modern blue for Google
        
        // Enhanced color palette with better distribution
        const colors = [
            '#6366f1', // Indigo
            '#8b5cf6', // Violet
            '#ec4899', // Pink
            '#f59e0b', // Amber
            '#10b981', // Emerald
            '#06b6d4', // Cyan
            '#ef4444', // Red
            '#3b82f6', // Blue
            '#14b8a6', // Teal
            '#f97316', // Orange
        ];
        
        return colors[announcement.committee % colors.length];
    };

    return (
        <li 
            className="announcement-page-card" 
            style={{ 
                borderLeft: `4px solid ${getCommitteeColor()}`,
                '--item-index': index 
            }}
        >
            {/* --- DELETE BUTTON (Only for DB items) --- */}
            {!isGoogle && (
                <button
                    className="delete-button-top"
                    onClick={() => onDelete(uniqueKey, announcement.source)}
                    aria-label="Delete announcement"
                    title="Delete announcement"
                >
                    ✕
                </button>
            )}

            {/* --- HEADER --- */}
            <h4 className="announcement-title">
                {isGoogle && (
                    <Calendar 
                        size={18} 
                        style={{ 
                            marginRight: '10px', 
                            color: getCommitteeColor(),
                            flexShrink: 0
                        }} 
                    />
                )}
                {announcement.header}
            </h4>

            {/* --- BODY (Message with Truncation) --- */}
            <p className="announcement-message">
                {isExpanded
                    ? announcement.message
                    : `${announcement.message.split(' ').slice(0, 40).join(' ')}${announcement.message.split(' ').length > 40 ? '...' : ''}`}
                
                {announcement.message.split(' ').length > 40 && (
                    <button
                        className="view-more-btn"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? " Show less" : " Read more"}
                    </button>
                )}
            </p>

            {/* --- FOOTER --- */}
            <div>
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    {/* Date Display */}
                    {isGoogle ? (
                        <span style={{ fontWeight: 500 }}>{announcement.time_to_send}</span>
                    ) : (
                        <FormattedTime datetime={announcement.time_to_send} />
                    )}

                    {/* Source/Author Display */}
                    {isGoogle ? (
                        <span style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '4px',
                            fontStyle: 'italic',
                            opacity: 0.8
                        }}>
                            <span>•</span>
                            <span>via Google Calendar</span>
                        </span>
                    ) : (
                        <span style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '4px' 
                        }}>
                            <span>•</span>
                            <span>{committeeName} {studentName}</span>
                        </span>
                    )}
                </span>

                {/* Tags Display */}
                {announcement.tags && announcement.tags.length > 0 && (
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                        {announcement.tags.map((tag, idx) => (
                            <span 
                                key={idx} 
                                className="tag"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </li>
    );
}
